import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import historyTradeActions from '../actions/history-trade'

export const useHistoryTrade = () => {
  const data = useSelector((state) => {
    return get(state, 'app.historyTradeManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(historyTradeActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
